'use client';

import { SingleStoreType } from '@workspace/interfaces';
import { FeatureCollection, Point } from 'geojson';
import { memo, useMemo } from 'react';
import { ClusteredMarkers } from './MarkerComponents/ClusteredMarkers';
import Supercluster, { ClusterProperties } from 'supercluster';
import { GeoJsonProperties } from 'geojson';

interface MarkerRendererProps {
  items: SingleStoreType[];
  handleMarkerClick: (store: SingleStoreType) => void;
  superclusterOptions: Supercluster.Options<GeoJsonProperties, ClusterProperties>;
}

const MarkerRendererComponent = ({ handleMarkerClick, items, superclusterOptions }: MarkerRendererProps) => {
  const geojson: FeatureCollection<Point, SingleStoreType> | null = useMemo(() => {
    if (!items?.length) return null;
    return {
      type: 'FeatureCollection',
      features: items.map((item) => ({
        type: 'Feature',
        id: item.objectID,
        geometry: {
          type: 'Point',
          coordinates: [item._geoloc.lng, item._geoloc.lat],
        },
        properties: item,
      })),
    };
  }, [items]);

  if (!geojson) {
    return null;
  }

  return (
    <ClusteredMarkers
      geojson={geojson}
      setInfoWindowData={handleMarkerClick}
      superclusterOptions={superclusterOptions}
    />
  );
};

// Memoize the component to prevent unnecessary re-renders
export const MarkerRenderer = memo(MarkerRendererComponent);
